var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "basic-chart-wrapper" }, [
    _c("canvas", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.isEmpty(_vm.pointList) && _vm.loadAllImages,
          expression: "!isEmpty(pointList) && loadAllImages",
        },
      ],
      ref: "canvasRef",
      class: [
        "matrix-canvas",
        `matrix-${_vm.chartType}${_vm.uuidv4Num}`,
        _vm.chartType,
      ],
      on: {
        click: _vm.handleCanvasClick,
        mousemove: function ($event) {
          _vm.isShowTooltip && _vm.handleMouseMove
        },
        mouseleave: _vm.hideTooltip,
      },
    }),
    _vm.chartType === "road" && _vm.chartFights.length > 0
      ? _c(
          "div",
          { staticClass: "tooltip-grid" },
          _vm._l(_vm.fightDataList, function (point, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "grid-cell",
                style: {
                  left: point.x + "px",
                  top: point.y + "px",
                  width: _vm.chartProps.gap + "px",
                  height: _vm.chartProps.gap + "px",
                },
                on: {
                  mouseover: function ($event) {
                    return _vm.showTooltip(index, $event)
                  },
                  mouseleave: _vm.hideTooltip,
                },
              },
              [
                _vm.tooltipIndex === index
                  ? _c("div", { staticClass: "chart-tooltip" }, [
                      _c(
                        "div",
                        { staticClass: "tooltip-content" },
                        [
                          _vm.tooltipData.isDraw
                            ? [
                                _c("div", { staticClass: "draw-tooltip" }, [
                                  _c(
                                    "div",
                                    { staticClass: "previous-result" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fight-number" },
                                        [
                                          _vm._v(
                                            "#" +
                                              _vm._s(
                                                _vm.tooltipData.previousFight
                                              )
                                          ),
                                        ]
                                      ),
                                      _c("img", {
                                        staticClass: "result-icon",
                                        attrs: {
                                          src: _vm.getTooltipIcon(
                                            point.val.previousResult
                                          ),
                                          alt: "previous result",
                                        },
                                      }),
                                      _c("span", { staticClass: "odds" }, [
                                        _vm._v(
                                          _vm._s(_vm.tooltipData.previousOdds) +
                                            "x"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("div", { staticClass: "current-result" }, [
                                    _c(
                                      "span",
                                      { staticClass: "fight-number" },
                                      [_vm._v("#" + _vm._s(point.val.fight))]
                                    ),
                                    _c("img", {
                                      staticClass: "result-icon",
                                      attrs: {
                                        src: _vm.getTooltipIcon(2),
                                        alt: "draw result",
                                      },
                                    }),
                                    _c("span", { staticClass: "odds" }, [
                                      _vm._v(
                                        _vm._s(_vm.tooltipData.currentOdds) +
                                          "x"
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]
                            : [
                                _c("span", { staticClass: "fight-number" }, [
                                  _vm._v("#" + _vm._s(point.val.fight)),
                                ]),
                                point.val.fight
                                  ? _c("img", {
                                      staticClass: "result-icon",
                                      attrs: {
                                        src: _vm.getTooltipIcon(
                                          point.val.result
                                        ),
                                        alt: "result",
                                      },
                                    })
                                  : _vm._e(),
                                _c("span", { staticClass: "odds" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getOddFromFight(point.val.fight)
                                    ) + "x"
                                  ),
                                ]),
                              ],
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }